import { DIRECTORY_UPLOAD_MODULES } from "../../../constants/directoryUploadModules";
import DirectoryUploadPage from "./DirectoryUploadPage";

export default function SsdiUploadRepoAgencies() {
  return <DirectoryUploadPage module={DIRECTORY_UPLOAD_MODULES["repo-agencies"]} />;
}
